import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "./inventory.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { Dialog } from "@progress/kendo-react-dialogs";
import moment from "moment";
import momentTZ from 'moment-timezone';
import { useDispatch, useSelector } from "react-redux";
import { REWARDS_DEFINITION_ADD, REWARDS_INVENTORY_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { createAndUpdateCampaign, createAndUpdateDefinition, fetchCampaignConfig, fetchRewardDefinitionDetail } from "../../../store/campaign";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import { TextArea, TextBox } from "@progress/kendo-react-inputs";
import { ComboBox, DropDownList, } from "@progress/kendo-react-dropdowns";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import DatePicker from "react-datepicker";
import { fetchUserById } from "../../../store/userMgmt";
import { fetchAllProviderList } from "../../../store/rewardsOperator";
import { RewardInventoryDefinitionSteps } from "./add_steps_definition";
import { RewardInventoryDefinitionHeader } from "./add_header_definition";
import { getCurrentLoggedInSessionTokenWithPromise } from "../../../config/userPool";
const { CAMPAIGN_IMAGE_UPLOAD_ENDPOINT } = config.api_endpoint;

export const CreateUpdateRewardDefinition = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const FileRef = useRef();
  const DocRef = useRef();

  const [imageLoading, setImageLoading] = useState(false);

  const [showSubmitConfirmDialog, setShowSubmitConfirmDialog] = useState(false);

  const minMinute = new Date(new Date().getTime() + 15 * 60000);

  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const AddPermission = checkPermission(
    userPermissions,
    "gamifications.create_campaign"
  );

  const EditPermission = checkPermission(
    userPermissions,
    "gamifications.update_campaign"
  );


  const { config_list } = useSelector(
    (state) => state.campaigns
  );

  const { provide_list } = useSelector(
    (state) => state.rewardsOperator
  );

  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [showPublishStartEndDateError, setShowPublishStartEndDateError] = useState(false);
  const [startEndDateErrorMessage, setStartEndDateErrorMessage] = useState("");

  const [file, setFile] = useState("");

  const [loading, setLoading] = useState(false);
  const [showDateError, setShowDateError] = useState(false);

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [errors, setErrors] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selected_tab, setSelectedTab] = useState(
    parseInt(query.get("state", 0)) || 0
  );
  const [rewardProvider, setRewardProvider] = useState({});
  const [rewardType, setRewardType] = useState({});


  const [error, setError] = useState({
    reward_name: "",
    provider_name: "",
    start_date: "",
    end_date: "",
    reward_type: "",
    reward_value: "",
    collection_details: "",
    what_to_bring: "",
    important_notes: "",
  });

  const [firstRequest, setFirstRequest] = useState(true);


  const [editData, setEditData] = useState({
    reward_name: "",
    start_date: "",
    end_date: "",
    start_time: null,
    end_time: null,
    images: [""],
    images_url: [""],
    point_cost: "",
    total_quota: "",
    reward_type: "",
    reward_value: "",
    collection_details: "",
    provider_name: "",
    what_to_bring: "",
    important_notes: "",
    link: ""
  });

  const getData = async () => {
    setLoading(true);
    if (id) {
      dispatch(fetchRewardDefinitionDetail(id)).then((res) => {


        let payload = res.payload;


        setEditData({
          ...editData,
          reward_name: payload.reward_name,
          start_date: payload.start_date
            ? momentTZ.tz(`${payload.start_date} ${payload.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",
          end_date: payload.end_date
            ? momentTZ.tz(`${payload.end_date} ${payload.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",

          start_time: payload.end_date && payload.end_time
            ? momentTZ.tz(`${payload.start_date} ${payload.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",
          end_time: payload.end_date && payload.end_time
            ? momentTZ.tz(`${payload.end_date} ${payload.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",



          images: payload.images.length > 0 ? [payload.images[0].key] : [''],
          images_url: payload.images.length > 0 ? [payload.images[0].url] : [''],
          point_cost: payload.point_cost,
          total_quota: payload.total_quota,
          reward_type: payload.reward_type,
          provider: payload.provider,
          provider_id: payload.provider_id,
          reward_value: payload.reward_value,
          collection_details: payload.collection_details,
          provider_name: payload.provider_name,
          what_to_bring: payload.what_to_bring,
          important_notes: payload.important_notes,
          link: payload.link
        });

        setRewardType({ name: payload.reward_type });
        setRewardProvider({ name: payload.provider_name, pk: payload.provider_id });

        setLoading(false);

      });
    } else {
      setLoading(false);

    }
  };

  const downloadRequiredData = async (callback) => {
    setLoading(true);
    dispatch(fetchUserById(localStorage.getItem("username"))).then(
      async (result) => {
        dispatch(fetchAllProviderList());
        dispatch(fetchCampaignConfig());
        getData();

      }
    );
  };


  useEffect(() => {
    downloadRequiredData();
  }, []);



  const backtoInformation = () => {
    navigate(REWARDS_DEFINITION_ADD + "?" + query.toString());
  };


  const checkMandatoryFields = () => {
    setShowDateError(false);
    setShowPublishStartEndDateError(false);

    const { start_date, start_time, end_date, end_time, name,
      reward_type,
      reward_value,
      collection_details,
      point_cost,
      total_quota,
      provider_name,
      what_to_bring,
      important_notes,
      reward_name
    } = editData;



    if (!start_date || !start_time || !end_date || !end_time || !reward_name || !reward_type || !point_cost || !total_quota
      || !reward_value || !collection_details || !provider_name || !what_to_bring || !important_notes
    ) {
      console.error("All date and time fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }



    const startDateTime = moment(`${moment(start_date).format("YYYY-MM-DD")} ${moment(start_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    const endDateTime = moment(`${moment(end_date).format("YYYY-MM-DD")}T${moment(end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    if (endDateTime <= startDateTime) {
      setShowDateError(true);
      return true;
    }


    if (endDateTime < new Date()) {
      setStartEndDateErrorMessage("End time has already passed. Please select a valid date and time.")
      setShowPublishStartEndDateError(true);
      return true;
    }




  };



  const handleSubmit = (isSaved) => {

    if (!isSaved) {
      if (checkMandatoryFields()) return;
    }

    setLoading(true);

    let updatedData = { ...editData };

    if (id) {  // Ensures id is neither null nor empty
      updatedData.id = id;
    }

    let start_date_time = moment(`${moment(editData.start_date).format("YYYY-MM-DD")} ${moment(editData.start_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    let end_date_time = moment(`${moment(editData.end_date).format("YYYY-MM-DD")} ${moment(editData.end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();


    updatedData.start_date = momentTZ(start_date_time).tz("Asia/Singapore").format("YYYY-MM-DD");

    updatedData.end_date = momentTZ(end_date_time).tz("Asia/Singapore").format("YYYY-MM-DD");

    updatedData.start_time = momentTZ(start_date_time).tz("Asia/Singapore").format("hh:mmA");
    updatedData.end_time = momentTZ(end_date_time).tz("Asia/Singapore").format("hh:mmA");

    updatedData.reward_type = rewardType.name;
    updatedData.provider = rewardProvider.name;
    updatedData.provider_id = rewardProvider.pk;


    dispatch(createAndUpdateDefinition({ data: updatedData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        const saved_id = payload.data?.id || id;
        getData();

        setLoading(false);

        navigate(REWARDS_INVENTORY_LIST);

      } else {
        setLoading(false);



      }
    });



  };



  const handleNext = () => {

    if (checkMandatoryFields()) return;


    let tab = parseInt(selected_tab) + 1;

    setSelectedTab(tab);
    setId(id);
    query.set("state", tab);
    navigate(REWARDS_DEFINITION_ADD + "?" + query.toString());
  };

  const callback_handleBackBtn = (e) => {

    if (parseInt(selected_tab) === 0) {
      navigate(REWARDS_INVENTORY_LIST);
      return;
    }

    let currentTab = selected_tab > 0 ? (selected_tab - 1) : 0;

    if (id) {
      query.set("id", id);
    }
    query.set("state", currentTab);

    setSelectedTab(currentTab);
    navigate(REWARDS_DEFINITION_ADD + "?" + query.toString());
  };


  const uploadFile = () => {

    FileRef.current.click();
  };

  const ImageHandler = () => {
    let url =
      id
        ? file === ""
          ? editData.images_url[0] !== "" && editData.images_url[0]
          : URL.createObjectURL(file)
        : file !== "" && URL.createObjectURL(file);
    let name =
      id
        ? file === ""
          ? editData.images_url[0] !== "" && editData.images_url[0].split("/")[5].split("?")[0]
          : file.name
        : file !== "" && file.name;
    return (
      <div className="inventory_create_file_main_box">
        <div className="inventory_create_file_child_box">
          <div>
            <img src={url} className="inventory_create_file_image" />
          </div>
          <div className="inventory_create_file_child_box_text">{name}</div>
        </div>
        <div>
          {AddPermission && (<span
            class="k-icon k-font-icon k-i-delete inventory_create_file_child_box_delete_icon"
            onClick={() => {
              setFile("");
              setEditData({
                ...editData,
                images: [""],
                images_url: [""]
              });
            }}
          />
          )}

        </div>
      </div>
    );
  };


  const onUploadFile = async (e) => {
    setImageLoading(true);
    const token = await getCurrentLoggedInSessionTokenWithPromise();
    const extension_ =
      e.type === "" ? e.name.split(".")[1] : e.type.split("/")[1];
    api
      .post(
        CAMPAIGN_IMAGE_UPLOAD_ENDPOINT,
        JSON.stringify({
          extensions: [extension_],
        }),
        token
      )
      .then((res) => {
        console.log(res);
        api.postDiff(res.data[0].presigned_url, e).then((res1) => {
          console.log(res1);
          if (res1 === 200) {
            setFile(e);
            setEditData({
              ...editData,
              images: [res.data[0].key],
            });
            setImageLoading(false);
          } else {
            alert("An error occured while uploading file! Please try again!");
          }
        });
      });
  };


  const mimeToExtension = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
  };




  const RenderRow = ({ title, value, isImage }) => {
    return (
      <>
        {value ? (
          <>
            <div className="inventory_detail_child_box_main_detail_items">
              <div className="inventory_detail_child_box_main_detail_items_title inventory_detail_center_item detail_padding_bottom">
                {title}
              </div>
              <div className="inventory_detail_child_box_main_detail_items_splitter" />
              <div className="inventory_detail_center_item inventory_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                {isImage ? (
                  <>
                    <img
                      style={{ height: "200px" }}
                      src={value}
                    />
                  </>
                ) : (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const getEndDateTime = () => {
    if (!editData.end_date || !editData.end_time) return null;

    const dateTime = moment(`${moment(editData.end_date).format("YYYY-MM-DD")} ${moment(editData.end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    return dateTime.isValid() ? dateTime.toDate() : null;
  };



  return (
    <>
      {AddPermission ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {imageLoading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 76px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          {(loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <RewardInventoryDefinitionHeader
            backBtncallback={(e) => callback_handleBackBtn(e)}
            state={selected_tab}
          />
          <RewardInventoryDefinitionSteps
            state={selected_tab}
            setState={setSelectedTab}
            checkMandatoryFields={checkMandatoryFields}
            handleSubmit={handleSubmit}
            editData={editData}
          />

          <div className="main-poll-survey-container">
            <div className="main-poll-survey">
              <div className="inventory_create_scroll_box">
                {selected_tab == 0 && (
                  <div>
                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_item_main_box_title">
                        Reward Name <span style={{ color: "red" }}>*</span>
                      </div>
                      <div>
                        <TextBox
                          className="inventory_create_item_main_box_field"
                          value={editData.reward_name}
                          disabled={!AddPermission}
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              reward_name: e.target.value,
                            })
                          }
                        />
                        {error.reward_name !== "" && (
                          <div className="inventory_create_error_text">
                            {error.reward_name}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_upload_main_box">
                        <div className="inventory_create_item_main_box_title">
                          Reward Image
                          <span className="inventory_create_item_main_box_title_span">
                            (Max 1 file, no more than 5MB each)
                          </span>
                        </div>
                      </div>
                      {!file && editData.images[0] === "" && (<div className="inventory_nodata_view">
                        <div className="inventory_nodata_title"> No image</div>
                        {AddPermission && (
                          <div className="inventory_create_upload_button_box">
                            <div onClick={uploadFile} >
                              <div>+ Upload Image</div>
                              <input
                                accept={[
                                  "image/jpeg",
                                  "image/png",
                                  "image/jpg",
                                  //   "application/pdf",
                                  //   "application/msword",
                                ]}
                                ref={FileRef}
                                type="file"
                                hidden
                                onClick={(e) => (e.target.value = "")}
                                onChange={(e) => onUploadFile(e.target.files[0])}
                              />
                            </div>
                          </div>
                        )}
                      </div>)}
                      {id
                        ? editData.images[0] !== "" && <ImageHandler />
                        : file !== "" && <ImageHandler />}
                    </div>

                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_item_main_box_title">
                        Reward Provider <span style={{ color: "red" }}>*</span>
                      </div>
                      <div className="inventory_add_dropdown margin-bottom">
                        <DropDownList
                          data={provide_list && provide_list.length > 0 ? provide_list : []}
                          value={rewardProvider}
                          dataItemKey="pk"
                          textField="name"
                          size={"large"}
                          disabled={!AddPermission}
                          className="inventory-dropdown"

                          onChange={(e) => {
                            setEditData({
                              ...editData,
                              provider_name: e.target.value.name,
                              provider_id: e.target.value.pk,
                            })
                            setRewardProvider(e.target.value)
                          }}
                          iconColor="#73007D"
                          iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"

                        />
                        {error.provider_name !== "" && (
                          <div className="inventory_create_error_text">
                            {error.provider_name}
                          </div>
                        )}
                      </div>
                    </div>



                    <div className="inventory_date_layout">
                      <div className="inventory_main_box margin-bottom">
                        <div className="inventory_main_box_title">Start Date <span style={{ color: "red" }}>*</span></div>
                        <div>
                          <DatePicker
                            dateFormatCalendar="MMMM"
                            className="poll-survey-date-picker"
                            selected={editData.start_date}
                            disabled={!AddPermission}
                            dateFormat="dd/MM/yyyy"

                            minDate={new Date()}
                            onChange={(date) => {
                              setEditData((prevData) => ({
                                ...prevData,
                                start_date: date,
                              }));
                            }}
                            customInput={<CustomDatePicker disabled={!AddPermission} />}
                          />
                        </div>

                      </div>

                      <div className="inventory_main_box margin-bottom">
                        <div className="inventory_main_box_title">Start Time <span style={{ color: "red" }}>*</span></div>
                        <div>
                          <TimePicker
                            placeholder={""}
                            className="info-datetime-picker keyboardInputDisable"
                            defaultValue={editData.start_time}
                            value={editData.start_time}
                            disabled={!AddPermission}

                            // min={""}
                            min={
                              editData.start_date === ""
                                ? minMinute
                                : moment(editData.start_date).format("DD-MM-YYYY") ===
                                  moment(new Date()).format("DD-MM-YYYY")
                                  ? minMinute
                                  : undefined
                            }
                            steps={{
                              hour: 1,
                              minute: 1,
                              // second: 30,
                            }}
                            onChange={(e) => {

                              setEditData((prevData) => ({
                                ...prevData,
                                start_time: e.target.value,
                              }));
                            }}
                          // required
                          />
                        </div>
                      </div>

                    </div>


                    <div className="inventory_date_layout ">
                      <div className="inventory_main_box  margin-bottom">
                        <div className="inventory_main_box_title">End Date <span style={{ color: "red" }}>*</span></div>
                        <div>
                          <DatePicker
                            dateFormatCalendar="MMMM"
                            selected={editData.end_date}
                            className="poll-survey-date-picker"
                            minDate={new Date()}
                            disabled={!AddPermission}
                            dateFormat="dd/MM/yyyy"

                            onChange={(date) => {
                              setEditData((prevData) => ({
                                ...prevData,
                                end_date: date,
                              }));
                              setClickDate(true);
                            }}
                            customInput={<CustomDatePicker disabled={!AddPermission} />}
                          />
                        </div>
                      </div>

                      <div className="inventory_main_box">
                        <div className="inventory_main_box_title">End Time <span style={{ color: "red" }}>*</span></div>
                        <div>
                          <TimePicker
                            placeholder={""}
                            className="info-datetime-picker keyboardInputDisable"
                            defaultValue={editData.end_time}
                            value={editData.end_time}
                            disabled={!AddPermission}

                            // min={""}
                            min={
                              editData.end_date === ""
                                ? minMinute
                                : moment(editData.end_date).format("DD-MM-YYYY") ===
                                  moment(new Date()).format("DD-MM-YYYY")
                                  ? minMinute
                                  : undefined
                            }
                            steps={{
                              hour: 1,
                              minute: 1,
                              // second: 30,
                            }}
                            onChange={(e) => {

                              setEditData((prevData) => ({
                                ...prevData,
                                end_time: e.target.value,
                              }));
                            }}
                          // required
                          />
                        </div>
                      </div>

                    </div>

                    <div className="inventory_date_layout">

                      <div className="inventory_create_item_main_box">
                        <div className="inventory_create_item_main_box_title">
                          Points/coupon  <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextBox
                            className="inventory_create_item_main_box_field"
                            inputMode="decimal"
                            pattern="^[0-9]*[.,]?[0-9]*$"
                            value={editData.point_cost}
                            disabled={!AddPermission}
                            onChange={(e) => {
                              let val = e.target.value;

                              // Allow only digits and one decimal point
                              if (/^\d*\.?\d*$/.test(val)) {
                                setEditData({
                                  ...editData,
                                  point_cost: val,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>

                      <div className="inventory_create_item_main_box">
                        <div className="inventory_create_item_main_box_title">
                          Total qty  <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextBox
                            className="inventory_create_item_main_box_field"
                            inputMode="decimal"
                            pattern="^[0-9]*[.,]?[0-9]*$"
                            value={editData.total_quota}
                            disabled={!AddPermission}
                            onChange={(e) => {
                              let val = e.target.value;

                              // Allow only digits and one decimal point
                              if (/^\d*\.?\d*$/.test(val)) {
                                setEditData({
                                  ...editData,
                                  total_quota: val,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="inventory_date_layout">

                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_create_item_main_box_title">
                          Reward Type <span style={{ color: "red" }}>*</span>
                        </div>
                        <div className="campaigns_add_dropdown">
                          <DropDownList
                            data={[{ name: "Physical" }]}
                            value={rewardType}
                            dataItemKey="name"
                            textField="name"
                            size={"large"}
                            disabled={!AddPermission}
                            className="inventory-dropdown"

                            onChange={(e) => {
                              setEditData({
                                ...editData,
                                reward_type: e.target.value.name,
                              })
                              setRewardType(e.target.value);

                            }}
                            iconColor="#73007D"
                            iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                          />
                          {error.category !== "" && (
                            <div className="campaigns_create_error_text">
                              {error.category}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="inventory_create_item_main_box">
                        <div className="inventory_create_item_main_box_title">
                          Reward Value  <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextBox
                            className="inventory_create_item_main_box_field"
                            value={editData.reward_value}
                            disabled={!AddPermission}
                            onChange={(e) => {
                              let val = e.target.value;

                              setEditData({
                                ...editData,
                                reward_value: val,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_item_main_box_background">
                        <div className="inventory_create_item_main_box_title">
                          Collection details <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextArea
                            className="inventory_create_item_main_box_field"
                            value={editData.collection_details}
                            disabled={!AddPermission}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                collection_details: e.target.value,
                              })
                            }
                            style={{ "borderRadius": "5px", minHeight: "100px" }}

                          />
                          {error.collection_details !== "" && (
                            <div className="inventory_create_error_text">
                              {error.collection_details}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_item_main_box_background">
                        <div className="inventory_create_item_main_box_title">
                          What to bring <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextArea
                            className="inventory_create_item_main_box_field"
                            value={editData.what_to_bring}
                            disabled={!AddPermission}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                what_to_bring: e.target.value,
                              })
                            }
                            style={{ "borderRadius": "5px", minHeight: "100px" }}

                          />
                          {error.what_to_bring !== "" && (
                            <div className="inventory_create_error_text">
                              {error.what_to_bring}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>


                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_item_main_box_background">
                        <div className="inventory_create_item_main_box_title">
                          Important Notes <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextArea
                            className="inventory_create_item_main_box_field"
                            value={editData.important_notes}
                            disabled={!AddPermission}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                important_notes: e.target.value,
                              })
                            }
                            style={{ "borderRadius": "5px", minHeight: "100px" }}

                          />
                          {error.important_notes !== "" && (
                            <div className="inventory_create_error_text">
                              {error.important_notes}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="inventory_create_item_main_box">
                      <div className="inventory_create_item_main_box_title">
                        URL
                      </div>
                      <div>
                        <TextBox
                          className="inventory_create_item_main_box_field"
                          value={editData.link}
                          disabled={!AddPermission}
                          onChange={(e) =>
                            setEditData({
                              ...editData,
                              link: e.target.value,
                            })
                          }
                        />

                      </div>
                    </div>





                  </div>
                )}

                {selected_tab == 1 && (
                  <div className="campaigns_create_item_main_box">
                    <div className="campaigns_create_item_main_box_title">
                      Reward Info
                    </div>
                    <div style={{ margin: "10px" }} className="margin-bottom">

                      <RenderRow
                        title={"Reward Name"}
                        value={editData.reward_name}
                        isImage={false}
                      />

                      <RenderRow
                        title={"Rewarded image"}
                        value={
                          file
                            ? URL.createObjectURL(file)
                            : editData.images_url[0]
                              ? editData.images_url[0]
                              : ""
                        } isImage={true}
                      />

                      <RenderRow
                        title={"Reward Partner"}
                        value={editData.provider}
                        isImage={false}
                      />

                      <RenderRow
                        title={"Start Date & Time"}
                        value={`${moment(editData.start_date, "YYYY-MM-DD").format('DD-MM-YYYY')} ${moment(editData.start_time).format("hh:mm A")}`}
                        isImage={false}
                      />

                      <RenderRow
                        title={"End Date & Time"}
                        value={`${moment(editData.end_date, "YYYY-MM-DD").format('DD-MM-YYYY')} ${moment(editData.end_time).format("hh:mm A")}`}
                        isImage={false}
                      />

                      <RenderRow
                        title={"Points/coupon"}
                        value={editData.point_cost}
                        isImage={false}
                      />

                      <RenderRow
                        title={"Reward Type"}
                        value={editData.reward_type}
                        isImage={false}
                      />

                      <RenderRow
                        title={"Reward Value"}
                        value={editData.reward_value}
                        isImage={false}
                      />


                      <RenderRow
                        title={"Collection details"}
                        value={editData.collection_details}
                        isImage={false}
                      />

                      <RenderRow
                        title={"What to Bring"}
                        value={`${editData.what_to_bring}`}
                        isImage={false}
                      />

                      <RenderRow
                        title={"Important Notes"}
                        value={`${editData.important_notes}`}
                        isImage={false}
                      />

                      <RenderRow
                        title={"URL"}
                        value={`${editData.link}`}
                        isImage={false}
                      />







                    </div>
                  </div>
                )}
              </div>

            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                {selected_tab !== 0 &&
                  <Button
                    className="footer-previous-btn font-family-poppins"
                    onClick={() => {
                      callback_handleBackBtn();
                    }}
                  >
                    Previous
                  </Button>
                }
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(REWARDS_INVENTORY_LIST);
                  }}
                >
                  Cancel
                </Button>
              </div>

              {selected_tab !== 1 &&
                <div className="footer-right">

                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleNext();
                    }}
                  >
                    Next
                    <Icon>
                      <img alt="" src={NextIcon} />
                    </Icon>
                  </Button>
                </div>
              }

              {selected_tab === 1 &&
                <div className="footer-right">
                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      setShowSubmitConfirmDialog(true);
                    }}
                  >
                    Submit
                  </Button>
                </div>
              }


            </div>
          </div>


          {showError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowError(false)}
            >
              <p>{errorMessage}</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowError(false)}
                >
                  OK
                </div>
              </div>
            </Dialog>
          )}


          {showPublishStartEndDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowPublishStartEndDateError(false)}
            >
              <p>{startEndDateErrorMessage}</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPublishStartEndDateError(false)}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {showDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowDateError(false)}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}



          {showSubmitConfirmDialog && (
            <Dialog
              className="alert-form"
              title={"Confirmation"}
              width={500}
              // height={280}
              onClose={() => setShowSubmitConfirmDialog(false)}
            >
              {
                <p className="campaigns-dialog-text-align"><b>Are you sure you want to submit this reward?</b></p>

              }

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setShowSubmitConfirmDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowSubmitConfirmDialog(false);
                    handleSubmit(false);
                  }}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}


        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
